import { useEffect, useMemo } from 'react';
import { ListLivestockInsurancePriceDatesResponse } from '../../../../../Generated/Raven-Demeter';
import Dropdown from '../../../../Components/Form/Inputs/Dropdown';
import formattingService from '../../../../Services/Formatting/FormattingService';
import useLanguage from '../../../../Services/Language/useLanguageHook';
import { GeneralRiskCalculationInputs } from '../DairyRevenueProtection/DairyRevenueProtectionDefinitions';

interface IGeneralRiskDateDropdownProps {
    calculationInputs: GeneralRiskCalculationInputs;
    setCalculatorInputs: (value: GeneralRiskCalculationInputs) => void;
    listLivestockInsurancePriceDatesResponse: ListLivestockInsurancePriceDatesResponse;
}

const GeneralRiskDateDropdown: React.FC<IGeneralRiskDateDropdownProps> = (props: IGeneralRiskDateDropdownProps) => {
    const [translations] = useLanguage();

    const dateOptions = useMemo(() => {
        if (!props.calculationInputs.insuranceYear) {
            return [];
        }

        return props.listLivestockInsurancePriceDatesResponse
            .rows!.find((x) => x.reinsuranceYear === props.calculationInputs.insuranceYear)
            ?.asOfDates.map((x) => ({
                label: formattingService.toShortDayMonthYear(x),
                value: formattingService.toApiDate(x),
            }));
    }, [props.calculationInputs.insuranceYear]) as { label: string; value: string }[];

    useEffect(() => {
        props.setCalculatorInputs({ ...props.calculationInputs, coverageEffectiveDate: dateOptions[0].value });
    }, [dateOptions]);

    return (
        <Dropdown
            value={props.calculationInputs.coverageEffectiveDate}
            options={dateOptions}
            handleOptionChange={(value) => props.setCalculatorInputs({ ...props.calculationInputs, coverageEffectiveDate: value })}
            label={translations.risk.margin.fields.coverageEffectiveDate}
            track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'CoverageEffectiveDateChanged' }}
        />
    );
};

export default GeneralRiskDateDropdown;
